import { Layout, Avatar, Typography, Popover, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useGlobal } from "../../../store/index";
import Logo from "./Logo.svg";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import { useHistory } from "react-router-dom";
import { MdSettings } from "react-icons/md";
import { BiLogOut } from "react-icons/bi";
import { IoLogOutOutline } from "react-icons/io5";

const { Header } = Layout;
const { Title, Link } = Typography;

const MenuBox = ({ label, onClick, renderIcon }) => {
  return (
    <div
      style={{
        flexDirection: "row",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Button onClick={onClick} type="ghost" style={{ border: 0, padding: 0 }}>
        {label}
      </Button>
      <div
        style={{
          marginLeft: "1rem",
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {renderIcon()}
      </div>
    </div>
  );
};

export default function Index() {
  const [globalState, globalActions] = useGlobal();
  const history = useHistory();
  const handleLogout = () => {
    localStorage.clear();
    if (sessionStorage.getItem("routing-path")) {
      history.push(sessionStorage.getItem("routing-path"));
    } else {
      history.push("/");
    }
    globalActions.authActions.signoutAction();
    window.location.reload();
  };

  const content = (
    <>
      <div>
        <MenuBox
          label="Profile Settings"
          onClick={() => {
            history.push("/profile-settings");
          }}
          renderIcon={() => <MdSettings size={20} color="#B4B7B6" />}
        />
        <div
          style={{
            marginTop: "0.5rem",
            marginBottom: "0.5rem",
            borderBottom: "0.5px solid rgb(233, 234, 233)",
          }}
        />

        <MenuBox
          label="Log out"
          onClick={() => {
            // globalActions.authActions.signoutAction();
            gaEvent(
              GA.EVENT.CLICK,
              GA.CATEGORY.LOGOUT,
              GA.DESCRIPTION.LOGOUT_BUTTON
            );
            handleLogout();
          }}
          renderIcon={() => <IoLogOutOutline size={20} color="#B4B7B6" />}
        />
      </div>
    </>
  );
  console.log(globalState);
  return (
    <Header
      style={{
        position: "fixed",
        zIndex: 100,
        width: "100%",
        background: "white",
        borderBottom: "1px solid #E9EAE9",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
          height: "58px",
          padding: "1rem",
        }}
      >
        <Title
          style={{
            // color: Colors.primaryColor,
            fontWeight: "normal",
            fontFamily: "Gilroy",
            fontSize: 25,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginTop: 17,
          }}
        >
          <a
            href="/"
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.LOGO,
                GA.DESCRIPTION.LOGO_IMAGE
              );
            }}
          >
            <img
              src={Logo}
              alt="sourcewiz"
              height={25}
              width={25}
              style={{ marginRight: "0.5rem" }}
            />
          </a>
          <Link
            href="/"
            style={{ color: "#000", paddingTop: "5px" }}
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.LOGO,
                GA.DESCRIPTION.LOGO_TEXT
              );
            }}
          >
            Sourcewiz
          </Link>
        </Title>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {/* <div>
            <Title
              level={5}
              style={{
                fontWeight: "bolder",
                marginRight: "1rem",
                cursor: "pointer",
              }}
            >
              Recent Activity
            </Title>{" "}
          </div>

          <div>
            <Title
              level={5}
              style={{
                fontWeight: "bolder",
                marginRight: "1rem",
                cursor: "pointer",
              }}
            >
              Help
            </Title>
          </div> */}

          <Popover
            placement="bottom"
            content={content}
            trigger="click"
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.AVATAR,
                GA.DESCRIPTION.AVATAR_POPOVER
              );
            }}
          >
            <Avatar
              style={{ backgroundColor: "#87d068", cursor: "pointer" }}
              icon={<UserOutlined />}
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.AVATAR,
                  GA.DESCRIPTION.AVATAR_ICON
                );
              }}
            />
          </Popover>
        </div>
      </div>
    </Header>
  );
}
